import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import classes from "./Login.module.css";

import loginImage from "./../assets/images/login.jpg";

const Login = () => {
  const navigate = useNavigate();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState();
  const [errorMessage, setErrorMessage] = useState(false);

  const onSubmit = () => {
    if (
      phoneNumber === "+998901234567" &&
      password === "123" &&
      role === `O'quvchi`
    ) {
      navigate("/student-panel/library");
      localStorage.setItem("isEntered", true);
    }
    if (
      phoneNumber === "+998901234567" &&
      password === "123" &&
      role === `Hodim`
    ) {
      navigate("/admin-panel/statistics");
      localStorage.setItem("isEntered", true);
    } else {
      setErrorMessage(true);
    }
  };

  const onChangeInput = (e, setState) => {
    setState(e);
    setErrorMessage(false);
  };

  return (
    <div className={classes["wrap"]}>
      <div className={classes["login_box"]}>
        <h1 className={classes["header"]}>Tizimga Kirish</h1>
        <div className={classes["error-message"]}>
          {errorMessage && "Telefon raqam yoki parol notogri"}
        </div>
        <input
          placeholder="Telefon raqamingiz"
          className={classes["inputs"]}
          type="text"
          onChange={(e) => {
            onChangeInput(e.target.value, setPhoneNumber);
          }}
        />
        <input
          placeholder="Parolingiz"
          className={classes["inputs"]}
          type="password"
          onChange={(e) => {
            onChangeInput(e.target.value, setPassword);
          }}
        />
        <h3 style={{ fontWeight: "400", marginTop: "5px" }}>
          Rolingizni tanlang:
        </h3>
        <div className={classes["role-wrapper"]}>
          <label htmlFor={`O'quvchi`} className={classes["role-label"]}>
            <input
              id={`O'quvchi`}
              name="role"
              type="radio"
              onChange={(e) => setRole(e.target.id)}
            />
            O'quvchi
          </label>
          <label htmlFor="Hodim" className={classes["role-label"]}>
            <input
              id="Hodim"
              name="role"
              type="radio"
              onChange={(e) => setRole(e.target.id)}
            />
            Hodim
          </label>
        </div>
        <div className={classes["flex"]}>
          <div className={classes["container"]}>
            <input type="checkbox" />
            <p className={classes["text"]}>Meni eslab qoling</p>
          </div>
          <p className={classes["text"]}>Parolingizni unitingizmi?</p>
        </div>
        <button onClick={onSubmit} className={classes["btn"]}>
          Kirish
        </button>
        <div className={classes["bottom_box"]}>
          <p className={classes["text"]}>Yangi foydalanuvchimisiz</p>
          <a className={classes["register_link"]} href="#">
            Ro'yxatdan o'tish
          </a>
        </div>
      </div>
      <img
        className={classes["img"]}
        src={loginImage}
        width={300}
        height={300}
        alt=""
      />
    </div>
  );
};

export default Login;
